

const GLOBAL_OBJECT = new Function('return this')();

/**
 * @param {*} any
 * @returns {Boolean}
 */
export default function(any) {
    return any === GLOBAL_OBJECT;
}


/** WEBPACK FOOTER **
 ** C:/OpenServer/domains/nervgh.io/sandbox/state-space/heuristic/src/recursive-iterator/lang/isGlobalObject.js
 **/